<template>
<div class="container">
    <div class="total-amount">{{ $t('order.o2o_errand_send.shipping_fee') }}<span class="order-amount">{{totalAmount}}{{ $t('general.dollar') }}</span><span class="detail" @click="amountPickerVisible=true">{{ $t('general.go_detail') }}<i class="iconfont">&#xe6ef;</i></span></div>

    <!--价格明细-->
    <mt-popup class="popup-amount-wrapper" v-model="amountPickerVisible">
        <div class="amount-wrapper">
            <div class="title">{{ $t('order.o2o_errand_send.shipping_fee_detail') }}</div>
            <div class="line-wrapper">
                <div class="left">{{ $t('order_detail.distance_price') }}: </div>
                <div class="right">{{distance_price}}{{ $t('general.dollar') }}</div>
            </div>
            <div class="line-wrapper" v-if="weight_price!=0">
                <div class="left">{{ $t('order_detail.weight_price') }}: </div>
                <div class="right">{{weight_price}}{{ $t('general.dollar') }}</div>
            </div>
            <div class="line-wrapper" v-if="time_price!=0">
                <div class="left">{{ $t('order_detail.time_price') }}: </div>
                <div class="right">{{time_price}}{{ $t('general.dollar') }}</div>
            </div>
            <div class="line-wrapper" v-if="gratuity!=0">
                <div class="left">{{ $t('order_detail.gratuity') }}: </div>
                <div class="right">{{gratuity}}{{ $t('general.dollar') }}</div>
            </div>
            <div class="line-wrapper">
                <div class="left">{{ $t('order.o2o_errand_send.shipping_fee_total') }}: </div>
                <div class="right">{{totalAmount}}{{ $t('general.dollar') }}</div>
            </div>
            <div class="link" @click="caculPickerVisible=true">{{ $t('order.o2o_errand_send.shipping_fee_rule') }}</div>
        </div>
    </mt-popup>

    <!--计价规则-->
    <mt-popup v-model="caculPickerVisible" position="right" class="common-popup-wrapper">
        <div class="common-header-wrap">
            <mt-header :title="$t('order.o2o_errand_send.shipping_fee_rule')" class="common-header">
                <mt-button slot="left" icon="back" @click="caculPickerVisible=false"></mt-button>
            </mt-header>
        </div>
        <div class="common-popup-content cacul-wrapper">
            <div class="cacul-title">{{ $t('order_detail.distance_price') }}</div>
            <div class="cacul-content">
                <div class="cacul-line-wrapper" v-for="(item,index) in config.o2o_errand_distance_price" :key="index">
                    <div class="left">{{item.title}}</div>
                    <div class="right">{{item.content}}</div>
                </div>
            </div>
            <div class="cacul-title">{{ $t('order_detail.weight_price') }}</div>
            <div class="cacul-content">
                <div class="cacul-line-wrapper" v-for="(item,index) in config.o2o_errand_weight_price" :key="index">
                    <div class="left">{{item.title}}</div>
                    <div class="right">{{item.content}}</div>
                </div>
            </div>
            <div class="cacul-title">{{ $t('order_detail.time_price') }}</div>
            <div class="cacul-content">
                <div class="cacul-line-wrapper" v-for="(item,index) in config.o2o_errand_time_price" :key="index">
                    <div class="left">{{item.title}}</div>
                    <div class="right">{{item.content}}</div>
                </div>
            </div>

        </div>
    </mt-popup>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { getErrandOrderDetailForFeePayment } from '@/api/memberO2oErrand'
export default {
  name: 'O2oErrandAmount',
  data () {
    return {
      totalAmount: 0,
      caculPickerVisible: false,
      time_price: 0,
      weight_price: 0,
      distance_price: 0,
      amountPickerVisible: false
    }
  },
  props: ['deliver_address_info', 'pickup_address_info', 'currentTime', 'currentGoodsWeight', 'gratuity'],
  created () {
    this.fetchConfig()
  },
  watch: {
    payload: {
      handler: function (val, oldval) {
        if (!val) {
          this.$emit('checkAmount', false, this.$t('order.o2o_errand_send.shipping_fee_loading'))
          this.totalAmount = ' -- '
        } else {
          const _this = this
          getErrandOrderDetailForFeePayment(val)
            .then(res => {
              const result = res.result
              _this.totalAmount = result.order_amount
              _this.time_price = result.time_price
              _this.weight_price = result.weight_price
              _this.distance_price = result.distance_price
              _this.$emit('checkAmount', true)
            })
            .catch(err => {
              _this.totalAmount = ' -- '
              _this.$emit('checkAmount', false, err.message)
              _this.$alert.error(err.message)
            })
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapState({
      config: state => state.config.config
    }),
    payload: function () {
      if (!this.deliver_address_info || !this.pickup_address_info || !this.config) {
        return false
      }
      return {
        o2o_errand_order_appointment_time: this.currentTime,
        o2o_errand_order_pickup_lat: this.pickup_address_info.address_latitude,
        o2o_errand_order_pickup_lng: this.pickup_address_info.address_longitude,
        o2o_errand_order_deliver_lat: this.deliver_address_info.address_latitude,
        o2o_errand_order_deliver_lng: this.deliver_address_info.address_longitude,
        o2o_errand_order_weight: this.currentGoodsWeight,
        o2o_errand_order_gratuity: this.gratuity
      }
    }
  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    })
  }
}
</script>

<style scoped lang="scss">
    .total-amount{
        .order-amount{margin: 0 .3rem;font-size:.9rem;}
        .detail{margin-left:.5rem;color: #3C87FA;
            i{font-size:.65rem;color:#3C87FA;margin-left: .2rem;}
        }
    }
    .popup-amount-wrapper{border-radius:.3rem;
        .amount-wrapper{padding:1rem;font-size:.7rem;
            .title{text-align: center;margin-bottom:1rem;}
            .line-wrapper{display:flex;margin-bottom:1rem;
                .left{flex:1;white-space: nowrap}
                .right{flex:1;text-align:right;white-space: nowrap}
            }
        }
        .link{text-align:center;color:#3c87fa}
    }
.cacul-wrapper{margin-top: 2rem; padding:.5rem;box-sizing:border-box;
    .cacul-title{font-size:.7rem;font-weight:bold;padding:.5rem 0;border-bottom:1px solid #eee;}
    .cacul-content{border-bottom:1px solid #eee;padding-bottom:1rem;
        .cacul-line-wrapper{display:flex;padding-top:1rem;font-size:.7rem;
            .left{flex:1;color:#6D7077}
            .right{flex:1;text-align:right}
        }
    }
}
</style>
